export default "__VITE_ASSET__5798ffcc__"